import { auth } from './firebase'

const { default: axios } = require('axios')

// Attach the signed-in staff member's Firebase ID token to outbound calls.
//
// These endpoints are Cloud Functions `onRequest` handlers, so — unlike
// httpsCallable — nothing attaches the caller's identity automatically.
// `doctorDashboard-addAgent` now rejects callers it cannot identify (it creates
// staff accounts and mints role claims), so the token has to be sent explicitly.
//
// Sending it is additive: endpoints that do not check the header ignore it.
// If no one is signed in we send no header and let the server decide.
const authHeaders = async () => {
  try {
    const user = auth?.currentUser
    if (!user) return {}
    return { Authorization: `Bearer ${await user.getIdToken()}` }
  } catch (error) {
    console.error('axios: could not attach ID token', error)
    return {}
  }
}

const POST = async (url, data) => {
  const config = {
    method: 'post',
    url,
    headers: {
      'Content-Type': 'application/json',
      ...(await authHeaders()),
    },
    data,
  }

  try {
    const response = await axios(config)
    return response.data
  } catch (error) {
    if (error.response && error.response.data) {
      const errorMessage =
        error.response.data.message || 'Errow occured while processing.'
      throw new Error(errorMessage)
    } else if (error.request) {
      throw new Error('No response received from server.')
    } else {
      throw new Error(error.message)
    }
  }
}

export const API = {
  POST,
}
